import { render, staticRenderFns } from "./MoleculeLoginCallback.vue?vue&type=template&id=15050d92"
import script from "./MoleculeLoginCallback.vue?vue&type=script&lang=js"
export * from "./MoleculeLoginCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports